import ReactDOM from "react-dom";
import Loader from "../LogoLoader";
import Loading from "../Loading";
import { Mask } from "./styles";

const loaderDom = document.getElementById("loader") as HTMLElement;

interface ComponentProps {
  visible: boolean;
}

const Component = ({ visible = false }: ComponentProps) => {
  return ReactDOM.createPortal(
    visible ? (
      <Mask visible={visible}>
        <Loading />
        Cargando...
      </Mask>
    ) : (
      <></>
    ),
    loaderDom
  );
};

export default Component;
